import Utils from './Utils.js';
import defaultAvatar from 'img/default-avatar.png';

const UserUtils = {
    hasAvatar:function(userProfile) {
        var url = Utils.deref(userProfile, 'avatar.url');
        return Boolean(url);
    },
    getAvatarURL:function(userProfile) {
        var url = Utils.deref(userProfile, 'avatar.url') || '';
        if(url.length===0) {
            url = defaultAvatar;
        }
        return url;
    }
}

export default UserUtils;



// WEBPACK FOOTER //
// ./src/utils/UserUtils.js